// extracted by mini-css-extract-plugin
export default {"eventCardBackground":"eventCardItem_eventCardBackground__SMzGp"};